import { render, staticRenderFns } from "./SendEmailinvites.vue?vue&type=template&id=37ef89d0&"
import script from "./SendEmailinvites.vue?vue&type=script&lang=js&"
export * from "./SendEmailinvites.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailinvites.vue?vue&type=style&index=0&id=37ef89d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports